/* eslint-disable @stylistic/max-len */
import type {RefObject} from 'react';

/**
 * The `MapIconProps` interface defines the properties for the MapIcon component.
 */
interface MapIconProps {
    /** CSS class to override default styling. */
    className?: string;
    /** Primary color of the icon. */
    color1?: string;
    /** Height of the icon. */
    height?: number | string;
    ref?: RefObject<SVGSVGElement>;
    /** Test ID for Cypress. */
    testId?: string;
    /** Width of the icon. */
    width?: number | string;
}

/**
 * Material Symbol "map" — outlined, weight 300.
 * Folded map icon for the Map navigation tab.
 *
 * @param props           The component props.
 * @param props.className CSS class override.
 * @param props.color1    Primary icon color.
 * @param props.height    Icon height.
 * @param props.ref       SVG element ref.
 * @param props.testId    Test identifier.
 * @param props.width     Icon width.
 * @returns A React SVG element.
 */
export const MapIcon = ({
    className = '',
    color1 = 'currentColor',
    height,
    ref,
    testId = 'MapIcon',
    width
}: MapIconProps) => (
    <svg
        ref={ref}
        className={className}
        data-cy={testId}
        fill={color1}
        height={height}
        viewBox="0 -960 960 960"
        width={width}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="m600-141.54-240-84-172.15 66.61q-17.69 6.85-32.77-3.92Q140-173.62 140-192.31v-524.61q0-11.85 6.35-21.27 6.34-9.42 17.81-13.65L360-818.46l240 84 172.15-66.61q17.69-6.85 32.77 3.34Q820-787.54 820-769.23v527.69q0 12.23-6.92 21.46-6.93 9.23-18.77 13.46L600-141.54Zm-30-73.38v-468l-180-62.93v468l180 62.93Zm60 0L760-258v-474l-130 49.08v468ZM200-228l130-49.85v-468L200-702v474Zm430-454.92v468-468Zm-300-62.93v468-468Z" />
    </svg>
);

MapIcon.displayName = 'MapIcon';